import { Locales } from '@/models/User';
import { Button, ButtonProps, createSvgIcon } from '@mui/material';
import {
  enUS,
  frFR,
  deDE,
  esES,
  itIT,
  jaJP,
  koKR,
  ruRU,
  zhCN,
  ptBR,
} from '@mui/x-data-grid/locales';
import type { DataGridPremiumProps, GridLocaleText } from '@mui/x-data-grid-premium';

type GetRowClassName = NonNullable<DataGridPremiumProps['getRowClassName']>;
type RowClassNameParams = Parameters<GetRowClassName>[0];

export function getDataGridLocale(selectedLocale: Locales | null): Partial<GridLocaleText> {
  switch (selectedLocale) {
    case 'frFR':
      return frFR.components.MuiDataGrid.defaultProps.localeText;
    case 'ptBR':
      return ptBR.components.MuiDataGrid.defaultProps.localeText;
    case 'deDE':
      return deDE.components.MuiDataGrid.defaultProps.localeText;
    case 'esES':
      return esES.components.MuiDataGrid.defaultProps.localeText;
    case 'itIT':
      return itIT.components.MuiDataGrid.defaultProps.localeText;
    case 'jaJP':
      return jaJP.components.MuiDataGrid.defaultProps.localeText;
    case 'koKR':
      return koKR.components.MuiDataGrid.defaultProps.localeText;
    case 'ruRU':
      return ruRU.components.MuiDataGrid.defaultProps.localeText;
    case 'zhCN':
      return zhCN.components.MuiDataGrid.defaultProps.localeText;
    case 'enUS':
    default:
      return enUS.components.MuiDataGrid.defaultProps.localeText;
  }
}

export function GridLocaleTextOverride(selectedLocale: Locales | null): Partial<GridLocaleText> {
  return getDataGridLocale(selectedLocale);
}

export function addEvenOddRowClassName(getRowClassName?: (params: RowClassNameParams) => string) {
  return (params: RowClassNameParams) => {
    const oddEvenClassName = params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
    if (getRowClassName == null) return oddEvenClassName;

    const otherClassNames = getRowClassName(params);
    return `${oddEvenClassName} ${otherClassNames}`;
  };
}

export const dataGridStringCompare = (a: string, b: string) => {
  const string1 = (a ?? '').trim().toLowerCase();
  const string2 = (b ?? '').trim().toLowerCase();

  return string1.localeCompare(string2); // Custom comparator for sorting dates
};

export function CustomExportButton(props: ButtonProps) {
  const ExportIcon = createSvgIcon(
    <path d='M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z' />,
    'AdvancedExport'
  );

  const buttonBaseProps: ButtonProps = {
    startIcon: <ExportIcon />,
  };

  return (
    <Button {...props} {...buttonBaseProps}>
      Advanced Export
    </Button>
  );
}
